import * as React from 'react';

import './Button.scss';

import {ButtonType, ButtonDisabled} from 'typescript/types/ButtonTypes';

type ButtonVariants =
  | 'link'
  | 'primary'
  | 'secondary'
  | 'text'
  | 'default'
  | 'white'
  | 'tertiary'
  | 'tertiary-outline'
  | 'text-white'
  | 'dark'
  | 'tertiary-outlined'
  | 'white-yellow'
  | 'empty';

interface IProps extends React.HTMLProps<HTMLButtonElement> {
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: ButtonDisabled;
  type?: ButtonType;
  variant?: ButtonVariants;
  dataCy?: string;
  className?: string;
}

const Button = ({children, onClick, disabled, type, variant, dataCy, className, ...rest}: IProps) => {
  return (
    <button
      {...rest}
      disabled={disabled}
      onClick={onClick}
      type={type}
      className={`btn btn--${variant} ${className ? className : ''}`}
      data-cy={dataCy}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  onClick: () => {},
  disabled: false,
  type: 'button',
  variant: 'primary',
  dataCy: '',
};

export default Button;
